import { render, staticRenderFns } from "./abnormalMsg.vue?vue&type=template&id=05de2bf8&scoped=true&"
import script from "./abnormalMsg.vue?vue&type=script&lang=js&"
export * from "./abnormalMsg.vue?vue&type=script&lang=js&"
import style0 from "./abnormalMsg.vue?vue&type=style&index=0&id=05de2bf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de2bf8",
  null
  
)

export default component.exports